import {Helmet} from 'react-helmet';
import {useControllers} from '../../../common/helpers/react/hooks/useControllers';

export default function HtmlHeadPresenter() {
    const title = useControllers().settings.get$('title').useState() ?? '';
    const subtitle = useControllers().settings.get$('subtitle').useState();

    const htmlTitle = subtitle
        ? `${subtitle} - ${title}`
        : title;

    return (
        <Helmet>
            <title>{htmlTitle}</title>
        </Helmet>
    );
}